import { useEffect, useState } from "react";
import { platformInfo } from "../Uitiles/platform";

const useOs = () => {
    const [os, setOs] = useState(null);
    useEffect(() => {
        const getOs = async () => {
            const os = await platformInfo();
            setOs(os);
        }
        getOs();
    }, []);
    return os;
}
export default useOs;
